import { Component } from '@angular/core';

import { of } from 'rxjs';

import {
  CamAmountComponent,
  CamDepartmentNameComponent,
  CamInvoiceTenantUrlDisplayerComponent,
  CamInvoicesService,
  CamMaintenanceStatusComponent,
  CamMaintenanceTenantUrlDisplayerComponent,
  CamMaintenancesService,
  CamOrganizationsService,
  CamPaymentStatusComponent,
  CamProjectStatusComponent,
  CamProjectTenantUrlDisplayerComponent,
  CamProjectsService,
  CamQuotationStatusComponent,
  CamQuotationTenantUrlDisplayerComponent,
  CamQuotationsService,
  DocumentAttachmentModal,
  InvoiceStatusComponent,
  MaintenanceStatus,
  MandateStatusComponent,
  MissionTypeComponent,
  PaymentExecutionStatusComponent,
  PaymentFlowStatusComponent,
  PaymentMethodComponent,
  PaymentStatus,
  ProjectProfileCardComponent,
  ProjectProfileComponent,
  UnitStatusComponent,
} from '@camelot/project';
import { MissionType, ProjectStatus, Unit } from '@camelot/services';
import { CamPermissionsService, CamUsersService } from '@camelot/user';

import { TestIdDirective } from '@camelot/testing-harness';

const TENANT_URL = 'https://tenant.example/entity';

const projectsServiceMock = {
  fetchDynamicProps$: () => of({ id: 'project-1', name: 'Project one' }),
  fetchProjectsByContact$: () => of([]),
  fetchTenantRoute$: () => of(TENANT_URL),
  projectByContact: { get$: () => of([]) },
  tenantRoute: { get$: () => of(TENANT_URL) },
};

const invoicesServiceMock = {
  fetchTenantRoute$: () => of(TENANT_URL),
  tenantRoute: { get$: () => of(TENANT_URL) },
};

const quotationsServiceMock = {
  fetchVersionTenantRoute$: () => of(TENANT_URL),
  tenantRoute: { get$: () => of(TENANT_URL) },
};

const maintenancesServiceMock = {
  fetchTenantRoute$: () => of(TENANT_URL),
  tenantRoute: { get$: () => of(TENANT_URL) },
};

const organizationsServiceMock = {
  department: { get$: () => of({ id: 'dep-1', name: 'Department one' }) },
  fetchDepartment$: () => of({ id: 'dep-1', name: 'Department one' }),
};

const permissionsServiceMock = {
  canAccess$: () => of(true),
  canDirectAccess: () => true,
  isAuthenticated: true,
};

const usersServiceMock = {
  currentUser: { get$: () => of({ id: 'user-1' }) },
  fetchCurrentUser$: () => of({ id: 'user-1' }),
};

@Component({
    imports: [
        CamAmountComponent,
        CamDepartmentNameComponent,
        CamInvoiceTenantUrlDisplayerComponent,
        CamMaintenanceStatusComponent,
        CamMaintenanceTenantUrlDisplayerComponent,
        CamPaymentStatusComponent,
        CamProjectStatusComponent,
        CamProjectTenantUrlDisplayerComponent,
        CamQuotationStatusComponent,
        CamQuotationTenantUrlDisplayerComponent,
        DocumentAttachmentModal,
        InvoiceStatusComponent,
        MandateStatusComponent,
        MissionTypeComponent,
        PaymentExecutionStatusComponent,
        PaymentFlowStatusComponent,
        PaymentMethodComponent,
        ProjectProfileCardComponent,
        ProjectProfileComponent,
        TestIdDirective,
        UnitStatusComponent,
    ],
    providers: [
        { provide: CamProjectsService, useValue: projectsServiceMock },
        { provide: CamInvoicesService, useValue: invoicesServiceMock },
        { provide: CamQuotationsService, useValue: quotationsServiceMock },
        { provide: CamMaintenancesService, useValue: maintenancesServiceMock },
        { provide: CamOrganizationsService, useValue: organizationsServiceMock },
        { provide: CamPermissionsService, useValue: permissionsServiceMock },
        { provide: CamUsersService, useValue: usersServiceMock },
    ],
    template: `
    <cam-project-status camTestId="cam-project-status" [status]="this.projectStatus" />
    <cam-project-tenant-url-displayer camTestId="cam-project-tenant-url-displayer" projectId="project-1" />
    <cam-project-profile camTestId="cam-project-profile" [project]="this.project" />
    <cam-project-profile-card camTestId="cam-project-profile-card" projectId="project-1" />
    <cam-billings-payment-status camTestId="cam-billings-payment-status" [status]="this.paymentStatus" />
    <cam-invoice-status camTestId="cam-invoice-status" [status]="1" />
    <cam-billing-amount camTestId="cam-billing-amount" [amount]="this.amount" />
    <cam-invoice-tenant-url-displayer camTestId="cam-invoice-tenant-url-displayer" invoiceId="invoice-1" />
    <cam-mandate-status camTestId="cam-mandate-status" [status]="1" />
    <cam-payment-execution-status camTestId="cam-payment-execution-status" [status]="1" />
    <cam-payment-flow-status camTestId="cam-payment-flow-status" [status]="1" />
    <cam-payment-method camTestId="cam-payment-method" [status]="1" />
    <cam-quotation-status camTestId="cam-quotation-status" [status]="this.quotationStatus" />
    <cam-quotation-tenant-url-displayer camTestId="cam-quotation-tenant-url-displayer" versionId="version-1" />
    <cam-maintenance-status camTestId="cam-maintenance-status" [status]="this.maintenanceStatus" />
    <cam-maintenance-tenant-url-displayer camTestId="cam-maintenance-tenant-url-displayer" maintenanceId="m-1" />
    <cam-mission-type camTestId="cam-mission-type" [type]="this.missionType" />
    <cam-department-name camTestId="cam-department-name" departmentId="dep-1" />
    <cam-unit-status camTestId="cam-unit-status" [unit]="this.unit" />
    <cam-document-attachment-modal camTestId="cam-document-attachment-modal" />
  `
})
export class ProjectCase {
  public amount = { excl: 100, incl: 121 };
  public maintenanceStatus = MaintenanceStatus.Active;
  public missionType = MissionType.Technical;
  public paymentStatus = PaymentStatus.NotPaid;
  public project = { name: 'Project one' };
  public projectStatus = ProjectStatus.InProgress;
  public quotationStatus = 1;
  public unit = Unit.Hour;
}
